export default {"src":"/kareline/_next/static/media/facebook-app-symbol.ba7863d2.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};